<template>
  <div class="dots">
    <!-- eslint-disable vue/no-unused-vars -->
    <span v-for="i in value" class="dots-filled"></span><span v-for="i in max - value" class="dots-outlined"></span>
  </div>
</template>
<script>
export default {
  props: ['max', 'value'],
};
</script>

<style lang="postcss">
.dots {
  display: flex;

  .dots-filled {
    margin-right: var(--space-2);
    box-sizing: border-box;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: var(--grey-medium);
  }

  .dots-outlined {
    margin-right: var(--space-2);
    box-sizing: border-box;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    font-size: var(--font-size-12);
    border: 1px solid var(--grey-light);
  }
}
</style>
